import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
//Componentes Material
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Fab from '@material-ui/core/Fab';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
//Ícones
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
//Componentes
import { Link } from 'react-router-dom';
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';


const styles = (theme) => ({
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    },
    paginationToolbar: {
        flexWrap: 'wrap'
    },
    paginationActions: {
        marginLeft: 'auto'
    }
});

/**
 * Listagem genérica de um recurso da API
 */
class GenericListPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.formatarPaginacao = this.formatarPaginacao.bind(this);
        //Estado inicial
        this.state = {
            items: [],
            pageSize: 10,
            page: 1,
            count: 0,
            carregando: true
        };
    }

    /**
     * Carrega os dados da API
     */
    async componentDidMount() {
        const { page, pageSize } = this.state;
        await this.atualizarDados(page, pageSize);
    }

    /**
     * Evento disparado quando há mudança na página selecionada
     * @param {*} event Dados do evento
     * @param {Number} newPage Número da nova página selecionada
     */
    async handleChangePage(event, newPage) {
        const { pageSize } = this.state;
        //O componente trabalha com o índice em base 0
        await this.atualizarDados(newPage + 1, pageSize);
    }

    /**
     * Evento disparado quando há alteração na quantidade de registros por página
     * @param {*} event Dados do event
     */
    async handleChangeRowsPerPage(event) {
        const { page } = this.state;
        await this.atualizarDados(page, event.target.value);
    }

    /**
     * Evento disparado quando o form de pesquisa é submetido
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleFormSubmit(event) {
        //Impede a propagação do evento
        event.preventDefault();
        //Atualiza a listagem
        this.atualizarDados(this.state.page, this.state.pageSize);
    }

    /**
     * Consulta os dados na API
     * @param {Number} page Número da página atual
     * @param {Number} pageSize Quantidade de registros por página
     */
    async atualizarDados(page, pageSize) {
        //Exibe o loader
        this.setState({ carregando: true });
        //Carrega os filtros adicionais
        let params = {};
        if (this.props.onFilter)
            params = await this.props.onFilter();
        //Chama a API de listagem
        const result = await this.props.controller.listar(page, pageSize, params);
        if (result.sucesso)
            this.setState({
                items: result.items,
                count: result.count,
                page: result.page,
                pageSize: result.pageSize,
                carregando: false //Indica que a consulta terminou
            });
    }

    /**
     * Retorna a informação da paginação formatada
     * @param {*} dados Informações das páginas disponíveis
     */
    formatarPaginacao({ from, to, count } ) {
        return `${from}-${to} de ${count}`;
    }
    
    /**
     * Renderiza o ícone apresentado na linha
     * @param {Object} item Objeto que está sendo renderizado
     * @param {Boolean} readOnly Indica se a listagem é somente leitura
     */
    renderRowIcon(item, readOnly) {
        if (this.props.onRenderItemEditIcon)
            return (this.props.onRenderItemEditIcon(item));
        else if (readOnly) 
            return (
                <IconButton aria-label="Visualizar" size="small" component={Link} to={`${this.props.resource}/${item.id}`}>
                    <VisibilityIcon />
                </IconButton>
            );
        else
            return (
                <IconButton aria-label="Editar" size="small" component={Link} to={`${this.props.resource}/${item.id}`}>
                    <EditIcon />
                </IconButton>
            );
    }

    /**
     * Renderiza o corpo da tabela de acordo com a quantidade de itens
     * @param {Array} items Lista contendo os registros retornados
     * @param {Boolean} readOnly Indica se a listagem é somente leitura
     */
    renderTableBody(items, readOnly) {
        if (items.length > 0)
            return items.map(item => (
                <TableRow key={item.id}>
                    {this.props.onRenderItem(item)}
                    <TableCell>
                        { this.renderRowIcon(item, readOnly) } 
                    </TableCell>
                </TableRow>
            ));
        else
            return (<TableRow><TableCell colSpan={this.props.columnNames.length + 1}>Nenhum registro encontrado</TableCell></TableRow>);
    }

    /**
     * Renderiza os nomes das colunas de acordo com o informado nas propriedades
     */
    renderColumnNames() {
        return this.props.columnNames.map(column => (
            <TableCell key={column}>{column}</TableCell>
        ));
    }

    render() {
        const { onLogout, classes, readOnly, children, usuario, empresa, permissoes } = this.props;
        let { page, pageSize, count, items, carregando } = this.state;

        //O componente trabalha com o índice com base 0
        page -= 1;
        if (count === 0) page = 0;

        return (
            <Layout onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando}>
                <form onSubmit={this.handleFormSubmit}>
                    { children }
                </form>
                <VitalizePaper>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {this.renderColumnNames()}
                                    <TableCell>{ readOnly ? 'Visualizar' : 'Editar' }</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderTableBody(items, readOnly)}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[10, 25, 50]}
                            rowsPerPage={pageSize}
                            page={page}
                            count={count}
                            labelDisplayedRows={this.formatarPaginacao}
                            labelRowsPerPage="Registros por página"
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            classes={{ toolbar: classes.paginationToolbar, actions: classes.paginationActions }}
                        />
                    </TableContainer>
                </VitalizePaper>
                {
                    !readOnly &&
                        <Fab component={Link} to={`${this.props.resource}/add`} className={classes.fab} color="primary" >
                            <AddIcon />
                        </Fab>
                }
            </Layout>
        );
    }
}

GenericListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Callback executado quando filtrar os dados para o usuário */
    onFilter: PropTypes.func,
    /** Identificação do recurso */
    resource: PropTypes.string.isRequired,
    /** Controlador do recurso */
    controller: PropTypes.shape({
        listar: PropTypes.func
    }).isRequired,
    /** Lista dos nomes das colunas */
    columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    /** Componentes que aparecerão no filtro */
    children: PropTypes.any,
    /** Função invocada para renderizar os itens da tabela */
    onRenderItem: PropTypes.func.isRequired,
    /** Função invocada para renderizar o ícone (opcional) */
    onRenderItemEditIcon: PropTypes.func,
    /** Indica se a listagem é somente leitura */
    readOnly: PropTypes.bool,
    /** Classes CSS utilizadas pela página */
    classes: PropTypes.shape({
        fab: PropTypes.any,
        paginationToolbar: PropTypes.any,
        paginationActions: PropTypes.any
    })
};

GenericListPage.defaultProps = {
    readOnly: false
};

export default withStyles(styles)(GenericListPage);
